import debounce from 'lodash/debounce';
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { createPluginState, getPluginState } from './plugin-factory';
import { SafePlugin } from '../local-safe-plugin';
import { aiSpellingGrammarPluginKey } from './ai-spelling-grammar-plugin-key';
import { createRealtimeAICommand } from './commands';

// HACK: This is for demo purposes only. DO NOT release this to production.
const refreshSpellingAndGrammar = async view => {
  const {
    state
  } = view;
  const {
    generativeAIApiUrl
  } = getPluginState(state);
  if (generativeAIApiUrl) {
    const cmd = await createRealtimeAICommand({
      state,
      generativeAIApiUrl,
      getFetchCustomHeaders: null
    });
    cmd(view.state, view.dispatch);
  }
};
const refreshSpellingAndGrammarDebounced = debounce(refreshSpellingAndGrammar, 1500, {
  maxWait: 5000
});
export function createAISpellingGrammarPlugin(options) {
  return new SafePlugin({
    key: aiSpellingGrammarPluginKey,
    state: createPluginState(options.dispatch, {
      isSpellingAndGrammarEnabled: false,
      changedParagraphFromPositions: [],
      diffObjects: [],
      decorationSet: DecorationSet.empty,
      generativeAIApiUrl: options.generativeAIApiUrl
    }),
    view() {
      return {
        // HACK: This is for demo purposes only. DO NOT release this to production.
        update: (view, prevState) => {
          const {
            isSpellingAndGrammarEnabled: wasSpellingAndGrammarEnabled
          } = getPluginState(prevState);
          const {
            isSpellingAndGrammarEnabled
          } = getPluginState(view.state);

          // This is going to perform an immediate spellcheck when the toggle occurs. But if the toggle is active and the
          // view updates then this will just debounce the spellcheck.
          if (isSpellingAndGrammarEnabled) {
            if (isSpellingAndGrammarEnabled !== wasSpellingAndGrammarEnabled) {
              // immediately spellcheck
              refreshSpellingAndGrammar(view);
            } else {
              // No point in checking spelling again if the text hasn't changed.
              if (prevState.doc.textContent === view.state.doc.textContent) {
                return;
              }
              refreshSpellingAndGrammarDebounced(view);
            }
          }
        },
        destroy: refreshSpellingAndGrammarDebounced.cancel
      };
    },
    props: {
      decorations: state => {
        const {
          isSpellingAndGrammarEnabled,
          decorationSet
        } = getPluginState(state);
        if (!isSpellingAndGrammarEnabled) {
          return DecorationSet.empty;
        }
        return decorationSet;
      },
      attributes: {
        spellcheck: 'false'
      }
    }
  });
}